import { render } from "./Project.vue?vue&type=template&id=0916191b&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=0916191b&scoped=true&lang=css"

import exportComponent from "/home/yazgaroth/code/guinze/guinze.v3/www/grand-place-des-guinzes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0916191b"]])

export default __exports__